module.exports = __webpack_public_path__ + "img/kommune-220.985f69fe.svg";